module.exports = __webpack_public_path__ + "media/images/application2/AppForm__radios__radio-1e10aaf2ef62738b8b6ccf9e8c25d4a3.svg";